import httpClient from "@/http/httpClient";

const module = {
  namespaced: true,
  state: () => {
    return {
      productionReportSections: {
        details: {
          url: "details",
          isLoading: false,
        },
        items: {
          url: "items",
          isLoading: false,
        },
        cuttingLength: {
          url: "cutting-length",
          isLoading: false,
        },
        cuttingSheet: {
          url: "cutting-sheet",
          isLoading: false,
        },
        pcSheet: {
          url: "pc-sheet",
          isLoading: false,
        },
        finance: {
          url: "finance",
          isLoading: false,
        },
      },
      items: {},
      orderReportError: null,
    };
  },
  getters: {
    items(state) {
      return state.items;
    },
  },

  actions: {
    productionReportLazyLoad({ commit, dispatch }, orderNumber) {
      commit("setOrderReportError", null);
      dispatch("loadProductionReportSection", {
        sectionName: "details",
        orderNumber,
      });
      dispatch("loadProductionReportSection", {
        sectionName: "items",
        orderNumber,
      });
      dispatch("loadProductionReportSection", {
        sectionName: "cuttingLength",
        orderNumber,
      });

      dispatch("loadProductionReportSection", {
        sectionName: "cuttingSheet",
        orderNumber,
      });
      dispatch("loadProductionReportSection", {
        sectionName: "pcSheet",
        orderNumber,
      });
      dispatch("loadProductionReportSection", {
        sectionName: "finance",
        orderNumber,
      });
    },
    async loadProductionReportSection(
      { commit, state },
      { sectionName, orderNumber }
    ) {
      let section = _.cloneDeep(state.productionReportSections[sectionName]);
      commit("updateSectionDetails", {
        sectionName,
        section: { ...section, isLoading: true },
      });
      try {
        let response = (
          await httpClient.get(
            `production-report/${orderNumber}/${section.url}`
          )
        ).data; //.data
        commit("setLazyLoadedItems", response);
      } catch (error) {
        commit("setOrderReportError", error);
      }
      commit("updateSectionDetails", {
        sectionName,
        section: { ...section, isLoading: false },
      });
    },
    async productionReview({ commit, dispatch }, orderNumber) {
      let items = (await httpClient.get(`production-review/${orderNumber}`))
        .data; //.data
      commit("items", items);
    },
  },
  mutations: {
    updateSectionDetails(state, { sectionName, section }) {
      state.productionReportSections[sectionName] = section;
    },
    setLazyLoadedItems(state, payload) {
      state.items = { ...state.items, ...payload };
    },
    items(state, payload) {
      state.items = payload;
    },
    setOrderReportError(state, error) {
      state.orderReportError = error;
    },
  },
};

export default module;
